import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";

import NProgress from "nprogress";

import store from "../store/store";
import mainRoutes from "./routes";

// import cookies from 'vue-cookies'

Vue.use(VueRouter);
Vue.use(VueMeta, {
    // The component option name that vue-meta looks for meta info on.
    keyName: "page"
});

const baseRoutes = [];

const routes = baseRoutes.concat(mainRoutes);

const router = new VueRouter({
    routes,
    // Use the HTML5 history API (i.e. normal-looking routes)
    // instead of routes with hashes (e.g. example.com/#/about).
    // This may require some server configuration in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    mode: "history",
    base: process.env.BASE_URL,
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
    // Check if auth is required on this route
    NProgress.start();

    // Check if auth is required on this route
    // (including nested routes).
    const authRequired = routeTo.matched.some(route => route.meta.authRequired);
    // console.log(">>>>>>>>>>>>>>>>>>>>>")
    // If auth isn't required for the route, just continue.
    if (!authRequired) return next();
    //console.log(store.getters["auth/getTok"])
    // If auth is required and the user is logged in...
    let token =store.getters["auth/getTok"]
    // console.log("auth/getTok>>>>>>>>>>>>>>>>>>>>>"+token)
    if (token != null) {
        // Validate the local user token...
        if (store.getters["system/userInfo"] == null) {
            // console.log(store.getters["auth/isTfa"]);
            await store.dispatch("system/updateUserInfo").then(response => {
                // Then continue if the token still represents a valid user,
                // otherwise redirect to login.
                // console.log(response.data)

                store.commit("system/updateUserInfoLoading", false);
                if (response.data.responseCode === "00") {
                    console.log('ragnar Lothbrok>>>>>>>',response.data.responseCode)
                    store.commit("system/updateIsUserInfoUpt", true);
                    let responseData = response.data;
                    store.commit("system/updateUserInfo", responseData);
                    // validateTwoFa()
                    next()
                } else {
                    console.log('Lothbrok>>>>>>>',response.data.responseCode)
                    next('/');
                }
            });
        } else {
            // await validateTwoFa()
            next()
        }

    } else {
        // await validateTwoFa()
        console.log("token == null>>>>>"+token == null)
        // eslint-disable-next-line no-constant-condition
        if (token == null) next('/')
        else next()
    }

    // If auth is required and the user is logged in...
    // if (store.getters["auth/getTok"]) {
    //     // Validate the local user token...
    //     return store.dispatch("auth/validate").then(validUser => {
    //         // Then continue if the token still represents a valid user,
    //         // otherwise redirect to login.
    //         validUser ? next() : redirectToLogin();
    //     });
    // }

    // If auth is required and the user is NOT currently logged in,
    // redirect to login.
    // redirectToLogin();

    // eslint-disable-next-line no-unused-vars
    // function redirectToLogin() {
    //     // Pass the original route to the login component
    //     return next("/");
    // }
    //
    // function redirectToTfa() {
    //     // Pass the original route to the login component
    //     return next("/twoFa");
    // }
    // eslint-disable-next-line no-unused-vars
    async function validateTwoFa() {
        if (Vue.$cookies.get("isTwoFa") === store.state.system.userInfo.id) {
            console.log("1.>>>>>>>>>",Vue.$cookies.get("isTwoFa"))
            // console.log("1.>>>>>>>>>",store.getters["auth/isTwoFa"])
            return next()
        }else{
            console.log("2.>>>>>>>>>",Vue.$cookies.get("isTwoFa"))
            // console.log("2.>>>>>>>>>",store.getters["auth/isTwoFa"])
            await store.dispatch("auth/updateTwoFaInfo").then(response => {
                store.commit("auth/updateAuthLoading", false);
                console.log("2.>>>>>>>>>22",Vue.$cookies.get("isTwoFa"))
                // console.log("2.>>>>>>>>>22",store.getters["auth/isTwoFa"])
                if (response.data.responseCode === "00") {
                    store.commit("auth/updateTfaScreen", "token");
                    console.log("2.>>>>>>>>>00",Vue.$cookies.get("isTwoFa"))
                }else{
                    console.log("2.>>>>>>>>>99",Vue.$cookies.get("isTwoFa"))
                    store.commit("auth/updateTfaScreen", "reg")
                }
            });
            return next('/two-fa')
        }
    }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
    // Create a `beforeResolve` hook, which fires whenever
    // `beforeRouteEnter` and `beforeRouteUpdate` would. This
    // allows us to ensure data is fetched even when params change,
    // but the resolved route does not. We put it in `meta` to
    // indicate that it's a hook we created, rather than part of
    // Vue Router (yet?).
    try {
        // For each matched route...
        for (const route of routeTo.matched) {
            await new Promise((resolve, reject) => {
                // If a `beforeResolve` hook is defined, call it with
                // the same arguments as the `beforeEnter` hook.
                if (route.meta && route.meta.beforeResolve) {
                    route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                        // If the user chose to redirect...
                        if (args.length) {
                            // If redirecting to the same route we're coming from...
                            // Complete the redirect.
                            next(...args);
                            reject(new Error("Redirected"));
                        } else {
                            resolve();
                        }
                    });
                } else {
                    // Otherwise, continue resolving the route.
                    resolve();
                }
            });
        }
        // If a `beforeResolve` hook chose to redirect, just return.
    } catch (error) {
        return;
    }

    // If we reach this point, continue resolving the route.
    next();
});

router.afterEach(() => {
    NProgress.done();
});

export default router